var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader',{attrs:{"breadcrumbsItems":_vm.items,"title":'Descargas Play Store'}}),_c('v-row',_vm._l((_vm.apps),function(app,i){return _c('v-col',{key:i,attrs:{"cols":"12","md":"3"}},[_c('AppDescarga',{attrs:{"title":app.title,"img":app.img,"link":app.link}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }